import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';
var PropTypes = React.PropTypes;

import Modal from '../../../../common/components/Modal';

var DeleteCategoryModal = createReactClass({

    handleDelete: function () {
        this.props.actions.delete.bind(
            null,
            this.props.category
        ).call();
    },

    render: function () {
        return (<Modal
            cancelModal={this.props.toggle}
            saveAction={<button className="btn btn-danger" onClick={this.handleDelete}>
                <i className="fa fa-trash-can"/> Delete
            </button>}>
            <Modal.Header>Delete Category</Modal.Header>
            <Modal.Body>
                <div className="alert alert-danger">
                    <strong>Are you sure?</strong>
                    <p>This cannot be undone!</p>
                    <hr/>
                    <strong>Note:</strong>
                    <p>Any Parent Category deleted will not delete the Categories assigned to it; all Sub Category references to the Parent will be reset.</p>
                </div>
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
        </Modal>);
    }

});

export default DeleteCategoryModal;
